import React, { Component } from 'react';
import { connect } from 'react-redux';

import Form from '../form';
import * as templateHelper from './templateHelper';

import get from 'lodash.get';
import { bindActionCreators } from 'redux';
import * as handlers from '../../modules/autocomplete';
import OptionalLabel from '../common/optionalLabel';

export class ManagedAutocomplete extends Component {
  constructor(props) {
    super(props);

    // Get the label and subtext from data store.
    this.path = this.props.path;
    this.label = templateHelper.getTranslation(props.label);
    this.inputLabel = templateHelper.getTranslation(props.inputLabel);
    this.subtext = templateHelper.getTranslation(props.subtext);
    this.searchEntity = props.entity;
    this.searchOnMount = this.props.hasOwnProperty("searchOnLoad") ? this.props.searchOnLoad : true;
    
    // Handle initial selected item if provided
    if (this.props.initialSelectedItem) {
      props.setSelectedItem(props.path, this.props.initialSelectedItem);
      // Set the display text in the search string if getItem function is available
      if (this.props.getItem) {
        const selectedOption = this.props.getItem(this.props.initialSelectedItem);
        if (selectedOption && selectedOption.text) {
          props.onSearchChange(props.path, selectedOption.text);
        }
      }
    } else {
      props.setSelectedItem(props.path, props.selected);
    }

    if (this.props.initialChange) {
      props.onChange(props.path, props.value, props.selected);
    }
  }

  componentDidMount() {
    if (!this.props.selected && !this.props.data && this.searchOnMount && !this.props.initialSelectedItem) {
      const request = this.props.request();
      request &&
        this.props.extendedSearchEntities(
          this.searchEntity,
          this.path,
          request,
          this.props.sessionKey
        );
    }
  }

  onValueChange = (evt, obj) => {
    const selected = this.getSelectedItem(obj.value);
    this.props.setSelectedItem(this.props.path, this.props.selected);
    this.props.onSearchChange(this.props.path, '');
    this.props.onChange(this.props.path, obj.value, selected);
  };

  clear = () => {    
    this.onSearchChange({}, { searchQuery: '' });
    this.onValueChange({}, { value: null });
    if (this.props.onClear) {
      this.props.onClear();
    }
  };

  getSelectedItem = (value) => {
    let list = get(this.props.data, 'list');
    // if we have list loaded
    if (list) {
      // get selected element
      return list.find((x) => x[this.props.returnField || "id"] === value);
    } else if (this.props.selected) {
      // if we have no list loaded but selected element
      return this.props.selected;
    } else if (this.props.initialSelectedItem && this.props.value === this.props.initialSelectedItem[this.props.returnField || "id"]) {
      // if we have an initial selected item and the value matches
      return this.props.initialSelectedItem;
    }
  };

  onSearchChange = (event, { searchQuery }) => {
    this.props.onSearchChange(this.props.path, searchQuery);
    clearTimeout(this.timer);
    if (!searchQuery) {
      return;
    }

    const request = this.props.request();
    // search query can have some custom values
    //  like id/1234
    //  we need to get a list of all those custom commands
    //  and remove them from the search query
    //  plus the remaining search query should be used for search
    const customCommands = searchQuery.match(/(\w+)\/(\d+)/g) || [];
    if (customCommands.length > 0) {
      const supportedCommands = ['id'];
      request.filters = request.filters || [];      
      customCommands.forEach((command) => {
        searchQuery = searchQuery.replace(command, '');
        const [key, value] = command.split('/');
        if (!key || !value) {
          return;
        }
        if (!supportedCommands.includes(key)) {
          return;
        }
        request.filters = request.filters.filter((filter) => filter.key !== key);
        request.filters.push({ key, operator: 'EqualTo', value});
      });
      searchQuery = searchQuery.trim();
    }
    request.text = searchQuery;

    this.timer = setTimeout(() => {
      this.props.extendedSearchEntities(
        this.searchEntity,
        this.path,
        request,
        this.props.sessionKey
      );
    }, 1200);
  };

  render() {
    const options = getOptions(
      this.props,
      this.props.data,
      this.props.selected
    );
    const selectedOption =
      this.props.selected && this.props.getItem(this.props.selected);
    const currentOption =
      selectedOption && selectedOption.value === this.props.value
        ? selectedOption
        : undefined;
    const label =
      this.props.validation && this.props.validation.required === false ? (
        <OptionalLabel>{this.label}</OptionalLabel>
      ) : (
        this.label
      );

    return (
      <Form.Autocomplete
        className={this.props.className}
        id={this.props.id}
        label={label}
        systemOnly={this.props.systemOnly}
        inputLabel={this.inputLabel}
        subtext={this.subtext}
        value={this.props.value}
        onChange={this.onValueChange.bind(this)}
        validation={this.props.validation}
        placeholder={this.props.placeholder}
        disabled={this.props.disabled}
        search={this.onSearchChange}
        searchQuery={this.props.searchString}
        selectedOption={currentOption}
        options={options}
        clear={this.clear}
        onClear={this.props.onClear}
        loading={this.props.loading}
        validationErrorMessage={this.props.validationErrorMessage}
      />
    );
  }
}

const getOptions = (config, data, selected) => {
  if (!config.getItem) {
    throw new Error(
      'Autocomplete should have getItem function to get data for each element'
    );
  }

  let options = [];

  if (data) {
    options = data.list
      .map((x) => config.getItem(x))
      .filter((x) => x !== undefined && x !== null);
  }

  if (selected) {
    const selectedOption = config.getItem(selected);
    if (
      (config.searchString === undefined || config.searchString === null) &&
      config.value === selectedOption.value
    ) {
      config.onSearchChange(config.path, selectedOption.text);
    }
  }

  return options;
};

const mapState = (state, ownProps) => {
  const loading =
    get(state, `autocomplete.${ownProps.path}.loading`) || ownProps.loading;
  const data = get(state, `autocomplete.${ownProps.path}.data`);
  const searchString =
    ownProps.searchString ||
    get(state, `autocomplete.${ownProps.path}.searchString`);
  const outerClear = get(state, `autocomplete.${ownProps.path}.outerClear`);

  const placeholder = templateHelper.getTranslation(ownProps.placeholder);
  return {
    sessionKey: state.session.key,
    loading,
    data,
    placeholder,
    searchString,
    outerClear,
    disabled:
      ownProps.disabled ||
      templateHelper.getState(
        state.templateBuilderEx,
        ownProps.path,
        'disabled'
      ),
    selected: templateHelper.getValue(
      state.templateBuilderEx,
      ownProps.selected
    ),
    value:
      ownProps.value ||
      templateHelper.getValue(state.templateBuilderEx, ownProps.path)
  };
};

const mapDispatch = (dispatch) => {
  return bindActionCreators(handlers, dispatch);
};

export const TemplateAutocomplete = connect(
  mapState,
  mapDispatch
)(ManagedAutocomplete);
